export default __webpack_public_path__ + "static/media/ant-design_mail-outlined.1e016544.svg";